import * as THREE from 'three';

import getWindowSize from '../../utils/getWindow.util';

export const toScreenXY = (
	position: THREE.Vector3,
	camera: THREE.PerspectiveCamera,
): THREE.Vector3 => {
	const sizes = getWindowSize();

	const normalized = position.project(camera);

	const mappedPosition = new THREE.Vector3(
		((normalized.x + 1) * sizes.width) / 2,
		(-(normalized.y - 1) * sizes.height) / 2,
		0,
	);

	return mappedPosition;
};
